import { defineTreeFilter } from '../engine/descriptor';
import type { FilterDefinition } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

/**
 * Module-scope default, read by the filter registry before any hook can run.
 * The metro taxonomy's levels — the live definition comes from
 * `useGeographyTaxonomy` via `FilterProvider`.
 */
export const geographyDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.GEOGRAPHY,
    name: 'Geography',
    selectionListIds: ['region', 'country', 'msa', 'city'],
    selections: [],
    branches: [
      { label: 'Region' },
      { label: 'Country' },
      { label: 'Metro Area' },
      { label: 'City' },
    ],
    type: FilterType.TREE,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_GEOGRAPHY },
});

export const geographyDefinition: FilterDefinition<TreeFilter> =
  geographyDescriptor.definition;
